var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrowser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    fill: "#713ee7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10,8l0.813-1.219C11.554,5.668,12.803,5,14.141,5H33.5c5.247,0,9.5,4.253,9.5,9.5V31c0,1.337-0.668,2.586-1.781,3.328 L40,35.141V14.5c0-3.59-2.91-6.5-6.5-6.5H10z",
    fill: "#713ee7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#713ee7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M36.5,15.5v22c0,2.209-1.791,4-4,4h-22c-2.209,0-4-1.791-4-4v-22c0-2.209,1.791-4,4-4h22C34.709,11.5,36.5,13.291,36.5,15.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5,10h-22C7.468,10,5,12.468,5,15.5v2C5,18.328,5.672,19,6.5,19h30c0.828,0,1.5-0.672,1.5-1.5v-2 C38,12.468,35.532,10,32.5,10z M10.5,16C9.672,16,9,15.328,9,14.5S9.672,13,10.5,13s1.5,0.672,1.5,1.5S11.328,16,10.5,16z M15.5,16 c-0.828,0-1.5-0.672-1.5-1.5s0.672-1.5,1.5-1.5s1.5,0.672,1.5,1.5S16.328,16,15.5,16z M32.5,16h-11c-0.828,0-1.5-0.672-1.5-1.5 s0.672-1.5,1.5-1.5h11c0.828,0,1.5,0.672,1.5,1.5S33.328,16,32.5,16z",
    fill: "#713ee7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowser);
export default __webpack_public_path__ + "static/media/browser.7dcb4f348fd9f19b130f9f5e5cbbf7c4.svg";
export { ForwardRef as ReactComponent };